(() => {
  let scheduled = false;
  let selectedVariantSku = '';

  function productSku(informationSection) {
    if (selectedVariantSku) return selectedVariantSku;

    const inlineSku = informationSection.querySelector('.flip-product-information__sku strong');
    if (inlineSku?.textContent.trim()) return inlineSku.textContent.trim();

    const skuLabel = Array.from(informationSection.querySelectorAll('dt'))
      .find((label) => label.textContent.trim() === 'FLIP SKU');
    return skuLabel?.nextElementSibling?.textContent.trim() || '';
  }

  function normalizeReviewBadge(reviewBlock) {
    const badge = reviewBlock.querySelector('.jdgm-prev-badge');
    const stars = badge?.querySelector('.jdgm-prev-badge__stars');
    const reviewText = badge?.querySelector('.jdgm-prev-badge__text');
    if (!badge || !stars || !reviewText) return false;

    const score = badge.dataset.averageRating || stars.dataset.score || '';
    const reviewCount = badge.dataset.numberOfReviews || '';

    let scoreElement = badge.querySelector('.flip-product-review-summary__score');
    if (!scoreElement) {
      scoreElement = document.createElement('span');
      scoreElement.className = 'flip-product-review-summary__score';
      scoreElement.setAttribute('aria-hidden', 'true');
      stars.insertAdjacentElement('afterend', scoreElement);
    }
    scoreElement.textContent = score;

    reviewText.textContent = `(${reviewCount})`;
    reviewText.setAttribute('aria-label', `${reviewCount} reviews`);

    if (reviewBlock.dataset.flipReviewNavigation !== 'ready') {
      reviewBlock.dataset.flipReviewNavigation = 'ready';
      reviewBlock.addEventListener('click', (event) => {
        if (!event.target.closest('.jdgm-prev-badge__stars, .jdgm-prev-badge__text')) return;
        document.querySelector('.jdgm-review-widget')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      });
    }

    return true;
  }

  function arrangeReviewSummary(productDetails, informationSection) {
    const reviewApp = productDetails.querySelector('[id*="judge_me_reviews_preview_badge"]');
    const reviewBlock = reviewApp?.closest('.product-block');
    const titleBlock = productDetails.querySelector(':scope > .product-block--title');
    if (!reviewBlock || !titleBlock) return null;

    let summary = productDetails.querySelector(':scope > .flip-product-review-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'flip-product-review-summary';
      productDetails.insertBefore(summary, titleBlock);
    }

    const sku = productSku(informationSection);
    let skuElement = summary.querySelector('.flip-product-review-summary__sku');
    if (sku && !skuElement) {
      skuElement = document.createElement('span');
      skuElement.className = 'flip-product-review-summary__sku';
      skuElement.innerHTML = 'FLIP SKU <span data-product-sku></span>';
      summary.insertBefore(skuElement, summary.firstChild);
    }
    if (skuElement) {
      skuElement.hidden = !sku;
      const skuValue = skuElement.querySelector('[data-product-sku]');
      if (skuValue) skuValue.textContent = sku;
    }

    if (reviewBlock.parentElement !== summary) summary.appendChild(reviewBlock);
    summary.dataset.reviewReady = String(normalizeReviewBadge(reviewBlock));
    return summary;
  }

  function segmentProductDescription(informationSection) {
    const description = informationSection.querySelector('.flip-product-information__description');
    const descriptionHeading = description?.querySelector(':scope > h3');
    const richText = description?.querySelector(':scope > .rte');
    if (!description || !descriptionHeading || !richText || description.classList.contains('is-segmented')) return;

    const groupedDescription = richText.querySelector(':scope > .product-description-v2');
    const groupedSections = groupedDescription
      ? Array.from(groupedDescription.children).filter((element) => element.tagName === 'DIV')
      : [];
    const sectionHeadings = Array.from(richText.children).filter((element) =>
      ['H2', 'H3', 'H4'].includes(element.tagName),
    );
    if (groupedSections.length < 2 && sectionHeadings.length === 0) return;

    const segments = document.createElement('div');
    segments.className = 'flip-product-information__segments';

    if (groupedSections.length >= 2) {
      groupedSections.forEach((group, index) => {
        const segment = document.createElement('section');
        segment.className = 'flip-product-information__segment';
        if (index === 0) segment.appendChild(descriptionHeading);
        Array.from(group.childNodes).forEach((node) => segment.appendChild(node));
        segments.appendChild(segment);
      });
    } else {
      let segment = document.createElement('section');
      segment.className = 'flip-product-information__segment';
      segment.appendChild(descriptionHeading);
      segments.appendChild(segment);

      Array.from(richText.childNodes).forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && ['H2', 'H3', 'H4'].includes(node.tagName)) {
          segment = document.createElement('section');
          segment.className = 'flip-product-information__segment';
          segments.appendChild(segment);
        }
        segment.appendChild(node);
      });
    }

    segments.dataset.count = String(segments.children.length);
    richText.replaceWith(segments);
    description.classList.add('is-segmented');
  }

  function arrangeProductPage() {
    scheduled = false;

    const productDetails = document.querySelector('.template-product .product-main .product-details');
    const informationSection = document.querySelector('.flip-product-information');
    if (!productDetails || !informationSection) return;

    const reviewSummary = arrangeReviewSummary(productDetails, informationSection);
    const priceBlock = document.querySelector('.product-main .product-block--price');
    const inventoryBlock = document.querySelector('.product-main .product-block--inventory_status');
    const formBlock = document.querySelector('.product-main .product-block--form');
    let buyBox = productDetails.querySelector('.flip-product-buybox');

    if (!buyBox && priceBlock && formBlock) {
      buyBox = document.createElement('div');
      buyBox.className = 'flip-product-buybox';
      buyBox.setAttribute('aria-label', 'Price, availability, and purchase options');
      productDetails.insertBefore(buyBox, priceBlock);
    }

    if (buyBox) {
      buyBox.dataset.layout = 'purchase-first-2026-09-15';
      [priceBlock, formBlock].forEach((block) => {
        if (block && block.parentElement !== buyBox) buyBox.appendChild(block);
      });

      const actionWrapper = formBlock?.querySelector('.product-form__action-wrapper');
      const addToCart = actionWrapper?.querySelector('.product-form--atc-button');
      if (inventoryBlock && addToCart) {
        actionWrapper.classList.add('flip-purchase-actions');
        if (inventoryBlock.nextElementSibling !== addToCart) {
          actionWrapper.insertBefore(inventoryBlock, addToCart);
        }
      }

      const priceContext = productDetails.querySelector('.flip-price-context');
      const deliveryCard = productDetails.querySelector('flip-delivery-estimate');
      const purchaseProof =
        productDetails.querySelector('[data-flip-product-purchase-proof]')
        || informationSection.querySelector('[data-flip-product-purchase-proof]');
      let previousCard = buyBox;
      [priceContext, deliveryCard, purchaseProof].forEach((card) => {
        if (!card) return;
        if (card.parentElement !== productDetails || card.previousElementSibling !== previousCard) {
          previousCard.insertAdjacentElement('afterend', card);
        }
        previousCard = card;
      });
    }

    const oemBlock = document.querySelector('.product-main .product-block--oem_cross_reference');
    const fitmentBlock = document.querySelector('.product-main .product-block--fitment_checker');
    const oemSlot = informationSection.querySelector('[data-flip-product-oem-slot]');
    const fitmentSlot = informationSection.querySelector('[data-flip-product-fitment-slot]');

    if (oemBlock && oemSlot && oemBlock.parentElement !== oemSlot) oemSlot.appendChild(oemBlock);
    if (fitmentBlock && fitmentSlot && fitmentBlock.parentElement !== fitmentSlot) fitmentSlot.appendChild(fitmentBlock);

    // The fitment station stays hidden (CSS) until at least one slot has content,
    // so a heading never renders above empty slots when blocks are missing or JS was late.
    const fitmentStation = informationSection.querySelector('.flip-product-information__fitment');
    if (fitmentStation && ((oemSlot && oemSlot.children.length) || (fitmentSlot && fitmentSlot.children.length))) {
      fitmentStation.classList.add('is-populated');
    }

    segmentProductDescription(informationSection);

    // Once every movable piece is in place (or absent from this product), stop
    // observing the document: nothing further can change the arrangement.
    const arrangementComplete =
      (!priceBlock || !formBlock || !!buyBox)
      && (!oemBlock || (oemSlot && oemBlock.parentElement === oemSlot))
      && (!fitmentBlock || (fitmentSlot && fitmentBlock.parentElement === fitmentSlot))
      && (
        !reviewSummary
        || (
          reviewSummary.parentElement === productDetails
          && reviewSummary.dataset.reviewReady === 'true'
        )
      );
    if (arrangementComplete && observer && document.readyState !== 'loading') {
      observer.disconnect();
      observer = null;
    }
  }

  function scheduleArrange() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(arrangeProductPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleArrange, { once: true });
  } else {
    scheduleArrange();
  }

  document.addEventListener('shopify:section:load', scheduleArrange);
  document.addEventListener('variant-change', (event) => {
    selectedVariantSku = event.detail?.variant?.sku || '';
    scheduleArrange();
  });

  // When the customer focuses the fitment input, expand the collapsed
  // "Show N more models" list so the full list is scannable while they type.
  document.addEventListener('focusin', (event) => {
    if (!event.target.matches || !event.target.matches('[data-flip-fitment-input]')) return;
    const container = event.target.closest('[data-flip-fitment]');
    if (!container) return;
    container.querySelectorAll('details.flip-fitment__all').forEach((details) => {
      details.open = true;
    });
  });

  let observer = new MutationObserver(scheduleArrange);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
